// Generated by ReScript, PLEASE EDIT WITH CARE


var en_BD = "en";

var bn_BD = "bn-BD";

var en_AE = "en-AE";

var en_TR = "en-TR";

var tr_TR = "tr-TR";

var en_IN = "en-IN";

var bdLocales = [
  en_BD,
  bn_BD
];

var aeLocales = [en_AE];

var trLocales = [
  en_TR,
  tr_TR
];

var indLocales = [en_IN];

var en = "en";

var bn = "bn";

var tr = "tr";

var enInd = "in";

var en_TK = "en-TK";

var en_string = "English";

var bn_string = "Bangla";

var ae_string = "English";

var tr_string = "Turkish";

var uae_default = en_AE;

var tr_default = tr_TR;

var bd_default = bn_BD;

var ind_default = en_IN;

export {
  en ,
  bn ,
  tr ,
  enInd ,
  en_BD ,
  bn_BD ,
  en_AE ,
  en_TR ,
  tr_TR ,
  en_TK ,
  en_IN ,
  bdLocales ,
  aeLocales ,
  trLocales ,
  indLocales ,
  en_string ,
  bn_string ,
  ae_string ,
  tr_string ,
  uae_default ,
  tr_default ,
  bd_default ,
  ind_default ,
}
/* No side effect */
